__turbopack_context__.v({
  "className": "librebaskervilleregular_5c281d93-module__xEetMq__className",
});
